/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadPlatformSubjectAlternative,
  WorkloadPlatformSubjectAlternative$inboundSchema,
} from "./workloadplatformsubjectalternative.js";

/**
 * The access rule a catalog platform produces by default, and the others the operator may choose instead.
 */
export type WorkloadPlatformSubject = {
  /**
   * Other rules the operator may choose instead, in the order they are offered. Absent where there are none.
   */
  alternatives?: Array<WorkloadPlatformSubjectAlternative> | undefined;
  /**
   * Names the default rule beside its alternatives. Empty where there are none.
   */
  label: string;
  /**
   * The subject with {key} placeholders for rule-tier variables; the stem, for a wildcard rule.
   */
  template: string;
  /**
   * Whether the rule is the filled template followed by *.
   */
  wildcard: boolean;
};

/** @internal */
export const WorkloadPlatformSubject$inboundSchema: z.ZodMiniType<
  WorkloadPlatformSubject,
  unknown
> = z.object({
  alternatives: z.optional(
    z.array(WorkloadPlatformSubjectAlternative$inboundSchema),
  ),
  label: z._default(z.string(), ""),
  template: z.string(),
  wildcard: z.boolean(),
});

export function workloadPlatformSubjectFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformSubject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformSubject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformSubject' from JSON`,
  );
}
